import React from 'react';

// Material ui
import { Grid } from '@material-ui/core';

// Components
import Typography from '@components/UI-KIT/Typography';
import PasswordInput from '@components/UI-KIT/Inputs/PasswordInput';
import Button from '@components/UI-KIT/Button';

interface Props {
    successfulChange: boolean;
    newPassword: string;
    NewPassHandler: (_value: string) => void;
    reEnterPass: string;
    reEnterPassHandler: (_value: string) => void;
    notEqual: boolean;
    returnToSession: () => void;
    changePassword: () => Promise<void>;
    PasswordError: boolean;
}
const ChangePasswordRequest: React.FC<Props> = ({
    successfulChange,
    newPassword,
    NewPassHandler,
    reEnterPass,
    reEnterPassHandler,
    notEqual,
    returnToSession,
    changePassword,
    PasswordError
}) => {

    return (
        <>
            { !successfulChange ? (
                <Grid>
                    <Grid
                        className="AOL-Session-main-login-frame"
                    >
                        <Typography
                            variant="h3"
                            color="primary-dark"
                        >
                            Cambiar contraseña
                        </Typography>
                        <Grid
                            className="AOL-Session-login-margin"
                        >
                            <Typography
                                variant="body-regular"
                                color="primary-dark"
                            >
                                Te damos estos consejos para que tu cuenta sea más segura<br/><br/>

                                • Escribe una clave que tenga 7 o más caracteres<br/>
                                • Que incluya al menos una mayúscula<br/>
                                • Que incluya al menos un número<br/>
                                • Que no tenga ni el nombre de tu negocio, barrio,<br/> dirección u otros elementos asociados a tu marca, rubro<br/> o datos personales.<br/>
                                • No uses la misma contraseña para todos tus sistemas.<br/>
                            </Typography>
                        </Grid>
                        <Grid
                            className="AOL-Session-login-recovery-margin"
                        >
                            <PasswordInput
                                value={newPassword}
                                onChange={NewPassHandler}
                                label="Nueva contraseña"
                                xs={12}
                            />
                            <Grid
                                className="AOL-Session-login-margin-password-change"
                            >
                                <PasswordInput
                                    value={reEnterPass}
                                    onChange={reEnterPassHandler}
                                    errorCase={notEqual}
                                    label="Reingresar contraseña"
                                    xs={12}
                                    errorLabel="Haz clic en el ojo y verifica que las contraseñas sean iguales"
                                />
                            </Grid>
                        </Grid>
                        <Grid
                            className="AOL-Session-login-recovery-margin"
                        >
                            <Button
                                level={1}
                                onClick={changePassword}
                                disabled={PasswordError}
                                label="Cambiar contraseña"
                                className="AOL-Session-recovery-btn"
                            />
                        </Grid>
                    </Grid>
                </Grid>
            ) : (
                <Grid>
                    <Grid
                        className="AOL-Session-main-login-frame"
                        style={{ marginTop: '8rem' }}
                    >
                        <Grid
                            container
                            wrap="nowrap"
                        >
                            <img
                                src="Base2.png"
                                alt="logo"
                            />
                            <Grid
                                className="AOL-Session-login-margin-change"
                            >
                                <Typography
                                    variant="h2"
                                    color="primary-dark"
                                >
                                    ¡Yei! ¡Tienes una nueva
                                    contraseña!
                                </Typography>
                            </Grid>
                        </Grid>
                        <Grid
                            className="AOL-Session-login-margin"
                        >
                            <Typography
                                variant="body-regular"
                                color="primary-dark"
                            >
                                Inicia sesión en Alquileres Online con tu nueva contraseña. Si no funciona, contacta a Soporte.
                            </Typography>
                        </Grid>
                        <Grid
                            className="AOL-Session-login-forms"
                        >
                            <Button
                                level={1}
                                onClick={returnToSession}
                                label="Iniciar sesión"
                                className="AOL-Session-recovery-btn"
                            />
                        </Grid>
                    </Grid>
                </Grid>
            )}
        </>
    );
};

export default ChangePasswordRequest;